// eslint-disable-next-line camelcase
import ct1_img from '../assets/img_1.png'

export const pointsList = [
  {
    name: '临沂',
    coordinate: [0.78, 0.41],
    halo: {
      show: true
    },
    icon: {
      src: ct1_img,
      width: 30,
      height: 30
    },
    text: {
      show: true
    }
  },
  {
    name: '美国',
    coordinate: [0.23, 0.40],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/us.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '加拿大',
    coordinate: [0.25, 0.30],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/ca.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '英国',
    coordinate: [0.47, 0.27],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/gb.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '德国',
    coordinate: [0.51, 0.32],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/de.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '意大利',
    coordinate: [0.51, 0.37],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/it.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '法国',
    coordinate: [0.49, 0.35],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/fr.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '荷兰',
    coordinate: [0.49, 0.31],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/nl.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '瑞典',
    coordinate: [0.52, 0.22],
    halo: {
      show: true,
      color: '#8378ea'
    },
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/se.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '西班牙',
    coordinate: [0.47, 0.38],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/es.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '墨西哥',
    coordinate: [0.22, 0.49],
    halo: {
      show: true,
      color: '#37a2da'
    },
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/mx.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '日本',
    coordinate: [0.83, 0.41],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/jp.png',
      width: 20,
      height: 20
    },
    length: 100

  },
  {
    name: '澳大利亚',
    coordinate: [0.83, 0.78],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/au.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '巴西',
    coordinate: [0.34, 0.69],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/br.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '印度',
    coordinate: [0.68, 0.50],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/in.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '阿联酋',
    coordinate: [0.62, 0.48],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/ae.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '沙特',
    coordinate: [0.59, 0.46],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/sa.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '新加坡',
    coordinate: [0.74, 0.61],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/sg.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '土耳其',
    coordinate: [0.56, 0.39],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/tr.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '波兰',
    coordinate: [0.53, 0.30],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/pl.png',
      width: 20,
      height: 20
    }

  }
]
export const colors = [
  '#fd27e1',
  '#ff2a04',
  '#f87d18',
  '#ff0',
  '#f5fff1',
  '#a8f807'
]
export const monthData = [
  {
    name: '一月',
    order: 300,
    amount: 150000
  },
  {
    name: '二月',
    order: 500,
    amount: 250000
  },
  {
    name: '三月',
    order: 650,
    amount: 370000
  },
  {
    name: '四月',
    order: 800,
    amount: 450000
  }, {
    name: '五月',
    order: 1000,
    amount: 650000
  }, {
    name: '六月',
    order: 1200,
    amount: 800000
  }, {
    name: '七月',
    order: 1100,
    amount: 700000
  }, {
    name: '八月',
    order: 1000,
    amount: 700000
  }, {
    name: '九月',
    order: '1400',
    amount: 650000
  }, {
    name: '十月',
    order: 900,
    amount: 500000
  }, {
    name: '十一月',
    order: 1650,
    amount: 690000
  },
]

function randomExtend (minNum, maxNum) {
  if (arguments.length === 1) {
    return parseInt(Math.random() * minNum + 1, 10)
  } else {
    if (minNum > 100000) {
      return (Math.random() * (maxNum - minNum + 1) + minNum).toFixed(2)
    }
    return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
  }
}

export const monthDataConfig = {
  header: ['月份', '订单数', '订单金额'],
  data: monthData.map(item => Object.values(item).map(key => {
    if (typeof key === 'number') {
      return randomExtend(key * 0.9, key * 1.1)
    }
    return key
  })),
  columnWidth: [220, 240, 280],
  align: ['center'],
  rowNum: 11,
  headerBGC: '#1981f6',
  headerHeight: 45,
  oddRowBGC: 'rgba(0, 44, 81, 0.8)',
  evenRowBGC: 'rgba(10, 29, 50, 0.8)'
}

export function formatter (number, n) {

  const numArr = number.toFixed(n).toString().split('.')
  const numbers = numArr[0].split('').reverse()
  const segs = []

  while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
  if (numArr[1]) {
    return segs.join(',').split('').reverse().join('') + '.' + numArr[1]
  }
  return segs.join(',').split('').reverse().join('')
}

export const totalTitle = [

  { name: 'user', title: '企业用户数量', color: '#4d99fc', width: 300, other: '企业用户数量' },
  { name: 'order_amount', title: '总交易额', color: '#f46827', width: 500, other: '服务订单总金额' },
  { name: 'order_total', title: '订单数量', color: '#4d99fc', width: 300, other: '处理订单总数' },

]
export const bottomTitle = [

  { name: 'order_unshipped_num', title: '未发货', color: '#4d99fc', width: 300, other: '企业用户数量' },
  { name: 'order_waiting_num', title: '待揽收', color: '#f46827', width: 500, other: '服务订单总金额' },
  { name: 'order_online_num', title: '在途', color: '#40faee', width: 300, other: '处理订单总数' },
  { name: 'order_success_num', title: '已签收', color: '#f46827', width: 300, other: '处理订单总数' },
  { name: 'order_unusual_num', title: '异常件', color: '#4d99fc', width: 300, other: '处理订单总数' },

]
